import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { LOGO_URL } from "@/lib/siteData";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 bg-gradient-to-br from-brand-purple-deep via-[#5b1a8a] to-brand-green-deep text-white overflow-hidden"
    >
      <div aria-hidden="true" className="absolute inset-0 opacity-20 bg-grain pointer-events-none" />
      {/* Top wave */}
      <svg
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        className="block w-full h-[40px] md:h-[60px] -mb-px"
        aria-hidden="true"
      >
        <path
          d="M0,40 C120,90 240,0 360,40 C480,80 600,0 720,40 C840,80 960,0 1080,40 C1200,80 1320,0 1440,40 L1440,0 L0,0 Z"
          fill="#FFFCF9"
        />
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="h-20 w-20 rounded-3xl bg-white/95 backdrop-blur flex items-center justify-center shadow-lg p-2">
              <img src={LOGO_URL} alt="Innovators Prep logo" className="h-full w-full object-contain" />
            </div>
            <div>
              <div className="font-display text-2xl font-bold">Innovators Prep</div>
              <div className="text-[12px] tracking-[0.2em] uppercase text-brand-yellow font-semibold">
                Play · Learn · Grow
              </div>
            </div>
          </div>
          <p className="mt-5 max-w-md text-white/80 leading-relaxed">
            A New York State-approved 4410 Preschool Special Education Program nurturing creativity,
            curiosity, and confidence in every child ages 2–5.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Explore</h4>
          <ul className="space-y-2 text-white/85 text-[15px]">
            <li><Link to="/" className="hover:text-brand-yellow">Home</Link></li>
            <li><Link to="/about" className="hover:text-brand-yellow">About</Link></li>
            <li><Link to="/programs/preschool" className="hover:text-brand-yellow">Preschool Program</Link></li>
            <li><Link to="/programs/special-education" className="hover:text-brand-yellow">Special Education</Link></li>
            <li><Link to="/approach" className="hover:text-brand-yellow">Our Approach</Link></li>
            <li><Link to="/term-dates" className="hover:text-brand-yellow">Term Dates & Planning</Link></li>
            <li><Link to="/goals" className="hover:text-brand-yellow">Our Goals</Link></li>
            <li><Link to="/philosophy" className="hover:text-brand-yellow">Philosophy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-semibold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-white/85 text-[15px]">
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-1 text-brand-yellow" />
              <span>4312 Church Ave<br />Brooklyn, NY 11203</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-brand-yellow" />
              <a href="tel:+17182823500" className="hover:text-brand-yellow">+1 (718) 282-3500</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-brand-yellow" />
              <a href="mailto:Innovatorsprep1@gmail.com" className="hover:text-brand-yellow break-all">
                Innovatorsprep1@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/15">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row justify-between items-center gap-3 text-[13px] text-white/70">
          <p>© 2025 Innovators Prep. All rights reserved.</p>
          <p className="font-semibold tracking-wider text-brand-yellow">PLAY · LEARN · GROW</p>
        </div>
      </div>
    </footer>
  );
}
